export const POST_USER_REQUEST= 'POST_USER_REQUEST';
export const POST_USER_SUCCESS= 'POST_USER_SUCCESS';
export const POST_USER_ERROR= 'POST_USER_ERROR';
export const AUTH= 'AUTH';